<mat-toolbar
  [ngClass]="themeService.theme()"
  role="navigation"
  aria-label="Main navigation"
>
  <mat-toolbar-row class="nav-row">
    <button
      id="menu"
      type="button"
      (click)="toggleSidenav()"
      [style]="burgerStyle()"
      mat-icon-button
      [attr.aria-label]="'nav.openMenu' | translate"
    >
      <mat-icon>menu</mat-icon>
    </button>
    <div [style]="buttonStyle()" class="flex-row flex-fxflex nav-links">
      <div class="nav-item flex-gap-20">
        <a
          mat-button
          [ngClass]="{ 'link-active': isActive() }"
          routerLink="/home"
          routerLinkActive="link-active"
        >
          <span class="mat-button-wrapper">
            <img alt="tehwolf.de" class="nav-logo" src="../../favicon.svg" />
            <span>{{ 'nav.home' | translate }}</span>
          </span>
        </a>
      </div>
      <div class="nav-item flex-gap-20">
        <a mat-button routerLink="/portfolio" routerLinkActive="link-active">
          <span class="mat-button-wrapper">
            <span>{{ 'nav.portfolio' | translate }}</span>
          </span>
        </a>
      </div>
      <div class="nav-item flex-gap-20">
        <a
          mat-button
          routerLink="/wordlist-generator"
          routerLinkActive="link-active"
        >
          <span class="mat-button-wrapper">
            <span>{{ 'nav.wordlistGenerator' | translate }}</span>
          </span>
        </a>
      </div>
      <div class="nav-item flex-gap-20">
        <a mat-button routerLink="/contact-form" routerLinkActive="link-active">
          <span class="mat-button-wrapper">
            <span>{{ 'nav.contactForm' | translate }}</span>
          </span>
        </a>
      </div>
      <div class="nav-item flex-gap-20">
        <button mat-button [matMenuTriggerFor]="appsMenu">
          <span class="mat-button-wrapper">
            <span>{{ 'nav.apps' | translate }}</span>
            <mat-icon>arrow_drop_down</mat-icon>
          </span>
        </button>
        <mat-menu #appsMenu="matMenu">
          @for (app of apps; track app.slug) {
            <a
              mat-menu-item
              [routerLink]="'/' + app.slug"
              routerLinkActive="link-active"
              >{{ app.title }}</a
            >
          }
        </mat-menu>
      </div>
    </div>
    @if (themeService.theme() === 'dark') {
      <button
        id="light"
        class="light-theme-button flex-gap-20"
        type="button"
        (click)="switchToLight()"
        [style]="buttonStyle()"
        mat-icon-button
        [attr.aria-label]="'nav.switchToLight' | translate"
      >
        <mat-icon>light_mode</mat-icon>
      </button>
    } @else {
      <button
        id="dark"
        class="dark-theme-button flex-gap-20"
        type="button"
        (click)="switchToDark()"
        [style]="buttonStyle()"
        mat-icon-button
        [attr.aria-label]="'nav.switchToDark' | translate"
      >
        <mat-icon>dark_mode</mat-icon>
      </button>
    }
    <tehw0lf-language-switcher [style]="buttonStyle()" />
    <div [style]="buttonStyle()">
      <div class="nav-item">
        <a mat-button target="_blank" href="https://github.com/tehw0lf">
          <span class="mat-button-wrapper">
            <img
              alt="tehwolf.de"
              class="nav-logo github"
              src="assets/icons/github.png"
            />
            <span class="github">{{ 'nav.github' | translate }}</span>
          </span>
        </a>
      </div>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
